export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtPujcovna';
export const NAME = 'Pujcovna';
